module.exports = __webpack_public_path__ + "static/media/newsletter-june-2018-icon.d08ed13e.jpg";